import { Link } from 'react-router-dom';
import I18n from '../../../config/i18n';
import { getSearchPathWithRequest } from '../../../features/request/helpers';
import { arePropsMissing, isLast } from '../../../utils/helpers';
import { Grid, Row, Col } from '../../../utils/grid/Grid';
import Section from '../../../utils/section/Section';
import SearchWidgetContainer from '../../../components/search/components/SearchWidgetContainer';
import SearchWidgetSmallContainer, {
  SearchParameterOverrides,
} from '../../../components/search/containers/SearchWidgetSmallContainer';
import TabNavigation from '../../../components/tabNavigation/TabNavigation';
import ThemeTeaser from '../../../components/themeTeaser/ThemeTeaser';
import HeroImage from '../../../components/heroImage/HeroImage';
import Meta from '../../../utils/meta/Meta';
import {
  LandingPageHeroImage,
  LandingPageSearchParams,
  LandingPageState,
} from '../../../routes/reducers/types';

import './LandingPage.css';

interface LandingPageProps extends LandingPageState {
  heroImage: LandingPageHeroImage & { image: string };
}

function buildParameterOverrides(
  searchParams?: LandingPageSearchParams,
): SearchParameterOverrides | undefined {
  if (!searchParams) {
    return undefined;
  }
  const overrides: SearchParameterOverrides = { ...searchParams };
  if (!searchParams.accommodation_type) {
    overrides.accommodation_type = '';
  }
  if (!searchParams.country_code) {
    overrides.country_code = '';
  }
  if (!searchParams.region_1) {
    overrides.region_1 = '';
  }
  overrides.region_2 = '';
  return overrides;
}

export default function LandingPage({
  heroImage,
  tabs,
  themes,
  meta,
  searchParams,
}: LandingPageProps): JSX.Element | null {
  if (arePropsMissing([heroImage, tabs, themes, meta])) {
    return null;
  }

  return (
    <div>
      <Meta title={meta.page_title} />
      <div className="landing-page-header">
        <Grid>
          <SearchWidgetContainer>
            <SearchWidgetSmallContainer
              withButton
              searchParameterOverrides={buildParameterOverrides(searchParams)}
            />
          </SearchWidgetContainer>
        </Grid>
        <HeroImage {...(heroImage as any)} />
      </div>
      <Section noGrid border small>
        <TabNavigation tabList={tabs} />
      </Section>
      {themes.map((theme, index) => (
        <Section border key={index}>
          <ThemeTeaser {...(theme as any)} />
          {isLast(index, themes) ? (
            <Row>
              <Col xs={12} md={6} lg={4}>
                <Link className="landing-page-more-button" to={getSearchPathWithRequest()}>
                  {I18n.t('landing_page.more_objects')}
                </Link>
              </Col>
            </Row>
          ) : null}
        </Section>
      ))}
    </div>
  );
}
